import { render, staticRenderFns } from "./ChangeLeverageModal.vue?vue&type=template&id=27d30636"
import script from "./ChangeLeverageModal.vue?vue&type=script&lang=js"
export * from "./ChangeLeverageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports